import AuthenticationContext from "contexts/AuthenticationContext";
import { useContext, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import sendRequest from "services/dataService";

export default function MoveToCritiqueModal({
  submission,
  show,
  onHide,
}: {
  submission: { id: number; title: string };
  show: boolean;
  onHide: (deleted: boolean) => void;
}) {
  const authenticationContext = useContext(AuthenticationContext);
  const ref = useRef<HTMLInputElement>(null);

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      await sendRequest({
        url: `api/v1.0/submission/${submission.id}/move-to-critique/`,
        method: "PUT",
        token: authenticationContext.token || "",
        body: JSON.stringify({ days: parseInt(ref.current?.value || "0") }),
      });
      onHide(true);
      toast.success("Submission moved to critique.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    } catch (error: any) {
      toast.error(error.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  };

  return (
    <Modal show={show} centered onHide={() => onHide(false)}>
      <Modal.Header>
        <Modal.Title>Confirm move submission to critique tab</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Are you sure you want to move <b>{submission.title}</b> to Critique
          tab?
        </p>
        <p className="pt-2">
          Add{" "}
          <input
            name="days"
            type="number"
            style={{ width: "40px", textAlign: "center" }}
            ref={ref}
            defaultValue="2"
          />{" "}
          days to due date.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" className="primary purple" onClick={onSubmit}>
          Move
        </Button>
        <Button
          variant="secondary"
          className="secondary grey"
          onClick={() => onHide(false)}
        >
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
